import { Box, Modal, Typography } from "@mui/material";
import { useState } from "react";
import { ButtonChangeCondition } from "./ButtonChangeCondition";
import { useConditionalContext } from "./ConditionalContext";

interface ConditionalEditorProps {
  currentCondition: any;
  setIsEditingCondition: (newCondition: boolean) => void;
}

export function ConditionalEditor(props: ConditionalEditorProps) {
  const [open, setOpen] = useState(true);
  const { selectedCondition, conditions } = useConditionalContext();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    // saveChangesAtPath(myModalContextValue, modalContextKey);
    setOpen(false);
    props.setIsEditingCondition(false);
  };

  let rows = [
    <tr key={"header"}>
      <td key={1}>Option name</td>
      <td key={2}>Value</td>
    </tr>,
  ];
  let i = 0;
  for (let check in props.currentCondition) {
    rows.push(
      <tr key={i++}>
        <td key={1}>{check}</td>
        <td key={2}>{"" + props.currentCondition[check]}</td>
      </tr>,
    );
  }

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box className="large-modal">
          <Typography>{selectedCondition}</Typography>
          <Box>
            {conditions!.length > 1 && (
              <>
                <ButtonChangeCondition delta={-1} />
                <ButtonChangeCondition delta={1} />
              </>
            )}
            <table>
              <tbody>{rows}</tbody>
            </table>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
